import React from "react";
import { Col, ProgressBar, Row } from "react-bootstrap";
import { isRgbColorEnabled, getScaleColors } from "../../../../../../../Helpers/RgbColorHelper";

export default function Summary_LoadingBar({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);
  const hitRange = item.scale.ranges.find((scale) => scale.isHit);

  // Check if RGB color is enabled using helper
  const rgbEnabled = isRgbColorEnabled(item.scale);

  // Get color variations using helper only if RGB is enabled
  const colors = rgbEnabled ? getScaleColors(item.scale) : null;

  // Conditional styles based on RGB color setting
  const nameStyle = rgbEnabled
    ? {
        fontSize: isSub ? "14px" : "16px",
        fontWeight: "600",
        lineHeight: "1.2",
        color: !isSub ? colors.dark : colors.primary,
      }
    : {
        // Override CSS classes to make smaller while keeping colors
        fontSize: isSub ? "14px" : "16px", // Override: 20px->14px, 22px->16px
        fontWeight: "600",
        lineHeight: "1.2",
      };

  const scoreStyle = rgbEnabled
    ? {
        fontSize: "12px",
        fontWeight: "600",
        backgroundColor: colors.primary,
        color: "#ffffff",
        border: `1px solid ${colors.dark}`,
        borderRadius: "50%", // Perfect circle
        padding: "0",
        width: "24px",
        height: "24px",
        minWidth: "24px",
        minHeight: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }
    : {
        // Override CSS classes to make smaller while keeping colors
        fontSize: "12px", // Override: 14px->12px
        fontWeight: "600",
        width: "24px", // Override: 30px/26px->24px
        height: "24px", // Override: 30px/26px->24px
        minWidth: "24px",
        minHeight: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "0",
      };

  // Create unique class name for this component instance to avoid conflicts
  const uniqueProgressBarClass = `pdf-progress-bar-${Math.random().toString(36).substr(2, 9)}`;

  const progressBarStyle = {
    height: "16px", // Made smaller: 18px->16px
    fontSize: "10px", // Made smaller: 11px->10px
    ...(rgbEnabled ? { backgroundColor: colors.light } : {}),
  };

  return (
    <Row style={{ height: Number(item.height) * 0.6, marginBottom: "0", padding: "2px 0" }}>
      <Col>
        <Row className="align-items-center" style={{ margin: "0" }}>
          <Col xs={4} className="align-content-center" style={{ padding: "0 8px" }}>
            <Row className="align-items-center justify-content-between" style={{ margin: "0" }}>
              <Col
                className={rgbEnabled ? "" : `text-16 ${isSub ? "_sub-scope-names-pdf" : "_main-scope-name-pdf"}`}
                style={nameStyle}
              >
                {item.name}
              </Col>
              <Col xs="auto" style={{ padding: "0" }}>
                <div
                  className={rgbEnabled ? "" : !isSub ? "_main-scope-score-pdf" : "_sub-scope-score-pdf"}
                  style={scoreStyle}
                >
                  {elementScore}
                </div>
              </Col>
            </Row>
          </Col>
          <Col xs={8} className="align-content-center" style={{ padding: "0 8px" }}>
            <ProgressBar
              variant={rgbEnabled ? undefined : isSub ? "sub-scope" : "main-scope"}
              label={`%${elementScore} ${hitRange?.text || ""}`}
              now={elementScore}
              style={progressBarStyle}
              className={uniqueProgressBarClass}
            />
            {rgbEnabled && (
              <style jsx>{`
                .${uniqueProgressBarClass} .progress-bar {
                  background-color: ${colors.primary} !important;
                  border: 1px solid ${colors.dark} !important;
                  border-radius: 0.375rem !important;
                }
              `}</style>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
